module.exports = __webpack_public_path__ + "static/media/Document5.29947e6b.svg";